import React, { useEffect, useState  } from "react"
import { enumUtil } from "../../../../../utils/Enum"
import { ServerRequestProtected } from "../../../../../utils/ServerDataRequest"
import Loader from "../../../../shared/Loader/Loader";
import Cookies from "js-cookie";
import { logIn } from "../../../../../actions/LoginAction";
import isNull from './../../../../../utils/NullChecking';
import { useDispatch, useSelector } from "react-redux";
import store from './../../../../../store/index';
import StatementPaymentDetail from "./StatementPaymentDetail";

const ViewStatement = (props) => {
    const dispatch = useDispatch();
    // console.log("browserNewTabContent", Cookies.get('cookedToken'))

    let token = Cookies.get('cookedToken')



    const getIdFromHashUrl = () => {
        const hash = window.location.hash;
        // "#/statementperview/9838085"
        const parts = hash.split('/');
        return parts[2] || null;
    };

    const ID = getIdFromHashUrl();

    console.log(ID, 'ID');



    let tokenn = store.getState();
    tokenn = token?.Login?.token
    let { isOpen, onClose, Genrate, Type, Include } = { ...props }
    const API_URL_controller = enumUtil.controller.PatientPayment

    const API_URL = process.env.REACT_APP_API + API_URL_controller + '/GeneratePrintStatement'
    const [isLoading, setIsLoading] = useState(false);
    const [printStatmentData, setPrintStatmentData] = useState([]);

    const [isOpenDetail, setIsOpenDetail] = useState(false)


    const LoadDataHistory = async () => {
        console.log(API_URL, 'API_URL');

        const patientId = getIdFromHashUrl(); // URL se ID uthao
        if (!patientId) {
            console.error("No Patient ID found in URL");
            return;
        }

        const requestBody = {
            "SearchCriteria": { PatientIDs: patientId + "" },
            "TableName": enumUtil.enumAPITableName.PRINTSTATEMENTS,
            "Value": "View"
        };


        console.log(requestBody, 'requestBody');


        setIsLoading(true);

        try {
            const response = await fetch(`${API_URL}`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
                body: JSON.stringify(requestBody)



            });

            if (!response.ok) throw new Error("API Error");

            const data = await response.json();
            console.log(data, 'data');
            setPrintStatmentData(data);
        } catch (error) {
            console.error("LoadDataHistory error:", error);
            setPrintStatmentData([]);
        } finally {
            setIsLoading(false);
        }
    };



    useEffect(() => {
        console.log(token, 'tokenn');

        if (!isNull(token)) {
            LoadDataHistory()
        }

    }, [token])

    console.log(printStatmentData, 'printStatmentData');

    const handleOpen = () => {
        setIsOpenDetail(true)
    }
    const handleClose = () => {
        setIsOpenDetail(false)
    }
    let popup = "";
    if (isOpenDetail) {
        popup = <StatementPaymentDetail isOpen={isOpenDetail} isClose={handleClose} />
    }




    const ThemeConfiguration = useSelector((state) => state.Theme?.theme) || JSON.parse(localStorage.getItem("themeConfig") || "null");
    return (
        <>
            {isLoading ? <Loader /> : null}
            {isOpenDetail ?

            <>
             { popup }
            </>
               
                :
                <div className="ar_review_confirm_payment">
                    <div className="ar_header">
                        <img src={process.env.PUBLIC_URL + "/assets/images/LogoPngNew.svg"} alt="" />
                    </div>
                    <div className="ar_content d-flex flex-column align-items-center justify-content-center gap-10">
                        <div className="text-center">
                            <p className="heading fs-25 balck-5-clr">Review & Confirm Payment</p>
                            <p className="text fs-13 balck-5-clr">Please review your statement details before proceeding to payment.</p>
                        </div>
                        <div className="d-flex gap-40 py-10 my-2">
                            <div className="ar-bg-box">
                                <p className="text font-m orange-drk">Billed By</p>
                                <p className="heading text-black fs-16">{printStatmentData?.[0]?.PracticeName}</p>
                                <p className="text text-black">{printStatmentData?.[0]?.Practice_Address}
                                    {/* <br />  Thousand Oaks, CA, 77090 */}
                                </p>
                            </div>
                            <div className="ar-bg-box">
                                <p className="text font-m orange-drk">Billed To</p>
                                <p className="heading text-black fs-16">{printStatmentData?.[0]?.PatientName}<span className="text text-black"> {printStatmentData?.[0]?.DOB} ({printStatmentData?.[0]?.Age}) {printStatmentData?.[0]?.Gender === 'F' ? 'Female' : 'Male'}</span></p>
                                <p className="text text-black">{printStatmentData?.[0]?.Address}

                                    {/* <br />  Thousand Oaks, CA, 77090 */}
                                </p>
                            </div>
                        </div>
                        <div className="">
                            <div className="ar_table  hover-scrollbar">
                                <table className="w-100">
                                    <thead>
                                        <tr>
                                            <th className="heading text-white">Date of Service</th>
                                            <th className="heading text-white">Description</th>
                                            <th className="heading text-white">Balance</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {printStatmentData?.[0]?.PatientClaims?.map((item, index) => (
                                            <tr key={index}>
                                                <td className="text text-black">{item.DOS}</td>
                                                <td className="text text-black">{item.Description}</td>
                                                <td className="text text-black">${item.Balance}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                            <div className="amount-footer mb-12">
                                <p className="text text-black"><span className="heading text-black">Amount to Pay: ${printStatmentData?.[0]?.PatientBalance}</span> - Please review your statement details before proceeding to payment.</p>
                            </div>

                            <div className="d-flex justify-content-end pt-10">
                                <button className="btn btn-orange px-3 h-100 fs-14 rounded py-1-5" onClick={handleOpen}>Proceed to Payment</button>
                            </div>
                        </div>
                    </div>

                    <div className="hs_footer d-flex flex-column justify-content-center align-items-center">
                        <p className="heading ar-light-color lh-24">{ThemeConfiguration?.configuration?.company?.name},  All Rights Reserved.</p>
                        <p className="text ar-light-color lh-24">
                            <a href="https://starhealthcare.co/PrivacyPolicy" target="blank" className="text ar-light-color text-decoration-none ar-hover-text">Privacy Policy</a> | <a href="https://starhealthcare.co/BusinessAssociateAgreement" target="blank" className="text ar-light-color text-decoration-none ar-hover-text">BAA</a>.
                        </p>
                    </div>


                </div>

            }


        </>
    )
}

export default ViewStatement



